//"use strict";
/* jshint esversion: 6 */

import * as THREE from 'three';
import * as Fontloader from 'three/examples/jsm/loaders/FontLoader.js';
import * as Textgeometry from 'three/examples/jsm/geometries/TextGeometry.js';

// import * as THREE from 'three/build/three.module.js';
// import * as Fontloader from 'three/examples/jsm/loaders/FontLoader.js';
// import * as Textgeometry from 'three/examples/jsm/geometries/TextGeometry.js';


//import * as THREE from '../resources/modules/three.js-master/build/three.module.js';
//import * as Fontloader from '../resources/modules/three.js-master/examples/jsm/loaders/FontLoader.js';
//import * as Textgeometry from '../resources/modules/three.js-master/examples/jsm/geometries/TextGeometry.js';


//import "https://aframe.io/releases/1.2.0/aframe.min.js";

// export function showInCanvas(canvasID) {
export function showInCanvas() {
    let createdCanvas = document.createElement('canvas');

    createdCanvas.id = "rotatingText";
    createdCanvas.style.width = '100%';
    createdCanvas.style.height = '99%';
    createdCanvas.style.padding = '0';
    createdCanvas.style.margin = '0';
    createdCanvas.style.border = '0';
    // createdCanvas.style.zIndex = 8;
    // createdCanvas.style.position = "absolute";
    // createdCanvas.style.border = "5px solid";
    createdCanvas.backgroundColor = "black";
    ///const canvas = document.querySelector('#' + canvasID);
    // const canvas = document.querySelector('#rotatingText');
    console.log("showInCanvas0");
   // let articleArea = document.getElementsByTagName("articleDiv");
    let articleArea = document.querySelector('#welcomeDiv');
    console.log("showInCanvas0.5");
    if (!articleArea) {
        console.log("articleArea not found")
    } else {
        articleArea.appendChild(createdCanvas);
    }

    // let canvas = document.getElementById("welcomeCanvas");



    // if (!createdCanvas) console.log("Canvas not found");

        const renderer = new THREE.WebGLRenderer({canvas: createdCanvas, alpha: true});

// export function showInCanvasWithCanvas(canvasEl) {
//     if (!canvasEl) return;
//     const renderer = new THREE.WebGLRenderer({ canvas: canvasEl, alpha: true });

    console.log("showInCanvas1");

    const fov = 75;
    const aspect = 2;  // the canvas default
    const near = 0.1;
    const far = 500;
    const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
    camera.position.z = 10;
  
    const scene = new THREE.Scene();
    const color = 0x1E8CFF;

    // scene.background = new THREE.Color(0.1176,0.5490,1.0)
    scene.background = new THREE.Color(color);
    // scene.fog = new THREE.Fog(color, 1, 100)

    console.log("showInCanvas2");
    {
      const color = 0xCCCCCC;
      const intensity = 1;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4);
      scene.add(light);
    }

    {
        const color = 0xAAAAFF;
        const intensity = 0.1;
        const light = new THREE.AmbientLight(color, intensity);
        light.position.set(-1, 2, 4);
        scene.add(light);
    }


    console.log("showInCanvas3");
    let parent = new THREE.Mesh();
    const loader = new Fontloader.FontLoader();
    const fontHelv = loader.load('../fonts/helvetiker_regular.typeface.json');
    loader.load('../fonts/helvetiker_regular.typeface.json', (font) => {
        const text1 = 'Willkommen';
        const text2= 'bei der';  
        const text3= 'Nusquam GmbH';

        const textParameters = {
            font: font,
            size: 6.5,
            height: 0.2,
            depth: 1.0,
            curveSegments: 24,
  
            bevelEnabled: true,  
            bevelThickness: 1.25,
            bevelSize: 0.25,        
            bevelSegments: 12,  
        
        };
            
        const geometry1 = new Textgeometry.TextGeometry(text1, textParameters);
        const geometry2 = new Textgeometry.TextGeometry(text2, textParameters);
        const geometry3 = new Textgeometry.TextGeometry(text3, textParameters);


        const color = 0xFFFFFF;
        const material = new THREE.MeshPhongMaterial({color});

        const rotText1 = new THREE.Mesh(geometry1, material);
        const rotText2 = new THREE.Mesh(geometry2, material);
        const rotText3 = new THREE.Mesh(geometry3, material);


        geometry1.computeBoundingBox();
        geometry1.boundingBox.getCenter(rotText1.position).multiplyScalar(-1);
  
        geometry2.computeBoundingBox();
        geometry2.boundingBox.getCenter(rotText2.position).multiplyScalar(-1);

        geometry3.computeBoundingBox();
        geometry3.boundingBox.getCenter(rotText3.position).multiplyScalar(-1);


        parent = new THREE.Object3D();
        parent.add(rotText1);
        parent.add(rotText2);
        parent.add(rotText3);

        rotText1.position.y = 16.0;
        rotText2.position.y = 8.0;
        rotText3.position.y = 0.0;

        scene.add(parent);
        parent.position.x = 0;
        parent.position.y = 0.0;
        parent.position.z = -40.0;
    });


    function resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement;
        const pixelRatio = window.devicePixelRatio;
        const width  = canvas.clientWidth  * pixelRatio | 0;
        const height = canvas.clientHeight * pixelRatio | 0;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
          renderer.setSize(width, height, false);
        }
        return needResize;
      }
  
    function render(time) {
      const timeMs = time * 0.001;
  
      if (resizeRendererToDisplaySize(renderer)) {
        const canvas = renderer.domElement;
        camera.aspect = canvas.clientWidth / canvas.clientHeight;
        camera.updateProjectionMatrix();
      }
  

      {
        const rot = timeMs * 0.25;
        parent.rotation.x = rot;
        parent.rotation.y = rot;
      }
      
  
      renderer.render(scene, camera);
  
      requestAnimationFrame(render);
    }
    console.log("showInCanvas4");
    requestAnimationFrame(render);
  }

//showInCanvas('rotatingText');

export default showInCanvas;

const module = {};
  